import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';

class BookingCategoryStore {

    // Properties

    // Modal Create/Update Properties

    @observable showBookingCategoryModal = false;
    @observable bookingCategoryTitle = '';

    @observable tabNameActiveKey = '1';
    @observable tabDescriptionActiveKey = '1';

    @observable bookingCategories = [];
    @observable id = 0;

    @observable name = '';
    @observable description = '';
    @observable bookingCategoryLanguages = [];

    @observable capacity = 1;
    @observable isAvailable = true;
    @observable maxHourPerDay = 0;
    @observable sortOrder = 0;

    @observable itemTextButton = 'Create';

    // Helper Properties

    @observable bookingCategoryListLoading = false;
    @observable bookingCategoryModalLoading = false;

    // Initialization

    @action initBookingCategory() {
        this.bookingCategoryListLoading = true;

        ApiCaller.BookingCategories.getAll().then(responseFirst => {
            if (responseFirst && responseFirst.isSuccess) {
                var model = responseFirst.model;
                this.bookingCategories = model;
                this.bookingCategoryListLoading = false;
            } else {
                this.bookingCategories = [];
                this.bookingCategoryListLoading = false;
            }
        });
    }

    @action initCreateBookingCategory(activeLanguages) {
        this.bookingCategoryTitle = 'Create Booking Category';

        this.id = 0;
        this.name = '';
        this.description = '';
        this.bookingCategoryLanguages = [];

        if (activeLanguages) {
            activeLanguages.forEach(lang => {
                this.bookingCategoryLanguages.push({
                    id: 0,
                    bookingCategoryId: 0,
                    langId: lang.id,
                    name: '',
                    description: ''
                });
            });
        }

        this.capacity = 1;
        this.isAvailable = true;
        this.maxHourPerDay = 0;
        this.sortOrder = 0;
        this.itemTextButton = 'Create';
        this.showBookingCategoryModal = true;
    }

    @action initUpdateBookingCategory(id, activeLanguages) {
        this.bookingCategoryModalLoading = true;
        this.bookingCategoryTitle = 'Update Booking Category';
        this.itemTextButton = 'Save';
        this.showBookingCategoryModal = true;

        ApiCaller.BookingCategories.getById(id).then(response => {
            if (response && response.isSuccess) {
                var model = response.model;
                this.id = model.id;
                this.name = model.name;
                this.description = model.description;
                this.bookingCategoryLanguages = model.bookingCategoryLanguages || [];
                if (activeLanguages) {
                    activeLanguages.forEach(lang => {
                        const existingLang = this.bookingCategoryLanguages.find(item => item.langId === lang.id);
                        if (!existingLang) {
                            this.bookingCategoryLanguages.push({
                                id: 0,
                                bookingCategoryId: this.id,
                                langId: lang.id,
                                name: '',
                                description: ''
                            });
                        }
                    });
                }
                this.capacity = model.capacity;
                this.isAvailable = model.isAvailable;
                this.maxHourPerDay = model.maxHourPerDay;
                this.sortOrder = model.sortOrder;
                this.itemTextButton = 'Save';
                this.bookingCategoryModalLoading = false;
            }
        });
    }

    // Transaction

    @action createBookingCategory() {
        this.bookingCategoryModalLoading = true;

        const request = {
            'name': this.name,
            'description': this.description,
            'bookingCategoryLanguages': this.bookingCategoryLanguages,
            'capacity': this.capacity,
            'isAvailable': this.isAvailable,
            'maxHourPerDay': this.maxHourPerDay,
            'sortOrder': this.sortOrder
        };

        return ApiCaller.BookingCategories.create(request).then((response) => {
            this.bookingCategoryModalLoading = false;

            if (response && response.isSuccess) {
                this.initBookingCategory();
                this.showBookingCategoryModal = false;
            }

            return response;
        });
    }

    @action updateBookingCategory() {
        this.bookingCategoryModalLoading = true;

        const request = {
            'id': this.id,
            'name': this.name,
            'description': this.description,
            'bookingCategoryLanguages': this.bookingCategoryLanguages,
            'capacity': this.capacity,
            'isAvailable': this.isAvailable,
            'maxHourPerDay': this.maxHourPerDay,
            'sortOrder': this.sortOrder
        };

        return ApiCaller.BookingCategories.update(request).then((response) => {
            this.bookingCategoryModalLoading = false;

            if (response && response.isSuccess) {
                this.initBookingCategory();
                this.showBookingCategoryModal = false;
            }

            return response;
        });
    }

    @action deleteUpdateBookingCategory(id) {
        this.bookingCategoryListLoading = true;

        return ApiCaller.BookingCategories.delete(id).then((response) => {
            this.bookingCategoryListLoading = false;
            if (response && response.isSuccess) {
                this.initBookingCategory();
            }
            return response;
        });
    }

    // SET Properties

    @action setShowBookingCategoryModal(value) {
        this.showBookingCategoryModal = value;
        if (!value) {
            this.tabNameActiveKey = '1';
            this.tabDescriptionActiveKey = '1';
        }
    }

    @action setBookingCategoryLanguageName(langId, value) {
        let lang = this.bookingCategoryLanguages.find(fi => fi.langId === langId);
        if (lang) {
            lang.name = value;
            // Set the main name to the primary language (English, langId = 1)
            if (langId === 1) {
                this.name = value;
            }
        }
    }

    @action setBookingCategoryLanguageDescription(langId, value) {
        let lang = this.bookingCategoryLanguages.find(fi => fi.langId === langId);
        if (lang) {
            lang.description = value;
            // Set the main description to the primary language (English, langId = 1)
            if (langId === 1) {
                this.description = value;
            }
        }
    }

    @action setCapacity(value) {
        this.capacity = value;
    }

    @action setIsAvailable(value) {
        this.isAvailable = value;
    }

    @action setMaxHourPerDay(value) {
        this.maxHourPerDay = value;
    }

    @action setSortOrder(value) {
        this.sortOrder = value;
    }

    @action setTabNameActiveKey(value) {
        this.tabNameActiveKey = value;
    }

    @action setTabDescriptionActiveKey(value) {
        this.tabDescriptionActiveKey = value;
    }
}

export default new BookingCategoryStore()
